import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  CurrencyBean,
  CurrencyExchangeRateBean,
  CurrencyExchangeRateSearchCriteria,
  RestCurrencyExchangeRateListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DatePickerComponent,
  InputTextbox,
  NumberFormatInputbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class CurrencyExchangeRateListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }
  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }

  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  editCurrencyCode = (e, val, rowData) => {
    if (e.detail === 1) this.props.editCurrencyCode(val, rowData);
  };
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  clickGoButton = (e) => {
    if (e.detail === 1) this.props.clickGoButton();
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let currencyExchangeRateList = this.props.currencyExchangeRateList;
    let currencyExchangeRateData = this.props.currencyExchangeRateData;
    return (
      <div>
        <div>
          <Row>
            <Col sm="2">
              <FormLabel id="searchBarLabel">CurrencyExchangeRate</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                name="code"
                onChange={this.onChange}
                value={currencyExchangeRateData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.enterKeyEventHandler}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.clickGoButton(e)}
              >
                {" "}
                Go
              </Button>
            </Col>
          </Row>
        </div>

        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "fromCurrencyCode")
                  }
                >
                  FromCurrencyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "fromCurrencyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "fromCurrencyName")
                  }
                >
                  FromCurrencyName{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "fromCurrencyName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "toCurrencyCode")}
                >
                  ToCurrencyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "toCurrencyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "toCurrencyName")}
                >
                  ToCurrencyName{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "toCurrencyName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {currencyExchangeRateList.map((Info, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.editCurrencyCode(e, Info.code, Info)}
                    >
                      {Info.code}
                    </Button>
                  </td>
                  <td> {Info.fromCurrencyCode}</td>
                  <td> {Info.fromCurrencyName}</td>
                  <td> {Info.toCurrencyCode}</td>
                  <td> {Info.toCurrencyName}</td>
                  <td> {Info.companyCode}</td>
                  <td> {Info.isActive}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          {currencyExchangeRateList.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class CurrencyExchangeRateEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }

  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  onCurrencyCodeChange = (e) => {
    this.props.onCurrencyCodeChange(e);
  };
  currencyCodeEnterKeyEvent = (e) => {
    this.props.currencyCodeEnterKeyEvent(e);
  };
  displayAutoCompleteCurrencyList = (e) => {
    this.props.displayAutoCompleteCurrencyList(e);
  };

  render() {
    let currencyExchangeRateData = this.props.currencyExchangeRateData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="2">
            {" "}
            <FormLabel>Company</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              onChange={this.onChange}
              value={currencyExchangeRateData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              ref={this.codeRef}
              name="code"
              type="text"
              placeholder="Enter CurrencyExchangeRateCode"
              onChange={this.onChange}
              value={currencyExchangeRateData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>Date</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <DatePickerComponent
              name="date"
              type="text"
              value={currencyExchangeRateData.date}
              onChange={this.onChange}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>From Currency Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onCurrencyCodeChange}
              name="fromCurrencyCode"
              value={currencyExchangeRateData.fromCurrencyCode}
              lookupRequired={true}
              lookupHandler={this.props.currencyLookupHandler}
              enterKeyEventHandler={this.currencyCodeEnterKeyEvent}
              autoCompleteListData={
                this.props.currencyCodePageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteCurrencyList}
              showAutoCompleteList={this.props.showAutoCompleteCurrencyCodeList}
              disabled={isDisableFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            <FormLabel>From Currency Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fromCurrencyName"
              type="text"
              onChange={this.onChange}
              value={currencyExchangeRateData.fromCurrencyName}
              style={{ "text-transform": "capitalize" }}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>To Currency Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.props.onToCurrencyCodeChange}
              name="toCurrencyCode"
              value={currencyExchangeRateData.toCurrencyCode}
              lookupRequired={true}
              lookupHandler={this.props.currencyLookupHandler}
              enterKeyEventHandler={this.props.toCurrencyCodeEnterKeyEvent}
              enableAutoCompleteTextBox={true}
              autoCompleteListData={
                this.props.tocurrencyCodePageListForAutoCompleteList
              }
              displayAutoCompleteList={
                this.props.todisplayAutoCompleteCurrencyList
              }
              showAutoCompleteList={
                this.props.showAutoCompletetoCurrencyCodeList
              }
              disabled={isDisableFields}
              isMandatory={true}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>To Currency Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="toCurrencyName"
              type="text"
              onChange={this.onChange}
              value={currencyExchangeRateData.toCurrencyName}
              style={{ "text-transform": "capitalize" }}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Actual Exchange Rate</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="actualExchangeRate"
              type="text"
              placeholder="ActualExchangeRate"
              onChange={this.onChange}
              value={currencyExchangeRateData.actualExchangeRate}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Adjusted Exchange Rate</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name="adjustedExchangeRate"
              type="text"
              placeholder="AdjustedExchangeRate"
              onChange={this.onChange}
              value={currencyExchangeRateData.adjustedExchangeRate}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class CurrencyExchangeRateList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      currencyExchangeRateList: [],
      response: {},
      pageTitle: "Currency Exchange Rate ",
      currencyExchangeRateData: new CurrencyExchangeRateBean(),
      pageList: new PageListBean(),
      criteria: new CurrencyExchangeRateSearchCriteria(),
      currency: new Array(),
      currentVendor: new CurrencyBean(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      isShowExitButton: true,
      error_list: [],
      totalCount: 0,
      isCurrencyExchangeRateListFormOpen: true,
      isCurrencyExchangeRateEntryFormOpen: false,
      isShowNodes: false,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowCode: false,
      currencies: [],
      isDisableFields: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      currencyCodePageListForAutoCompleteList: new Array(),
      showAutoCompleteCurrencyCodeList: false,
      currencyLookupHandler: null,
      tocurrencyCodePageListForAutoCompleteList: new Array(),
      showAutoCompletetoCurrencyCodeList: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let currencyExchangeRateData = new CurrencyExchangeRateBean();
    currencyExchangeRateData.companyCode = this.companyCode;
    const { cache } = appData;
    this.cache = cache;
    this.loadCacheDetails();
    this.loadPage(1);
    this.setState({ currencyExchangeRateData: currencyExchangeRateData });
    this.cleardata();
    this.initLookupHandlers();
  }
  loadCacheDetails = (e) => {
    const attribute_cache = { ...this.cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let currencies = this.state.currencies;
    if (
      attribute_cache.currencies != null ||
      attribute_cache.currencies != undefined
    ) {
      currencies = attribute_cache.currencies;
    }
    this.state.currencies = currencies;
    this.setState({ currencies: currencies });
  };
  moduleCaption = "Currency Exchange Rate";

  initLookupHandlers = () => {
    let currencyLookupHandler = new GenericAttributeLookupHandler(
      this.state.currencies,
      "Currency"
    );
    this.setState({ currencyLookupHandler: currencyLookupHandler });
  };

  cleardata = () => {
    let currencyExchangeRateData = new CurrencyExchangeRateBean();
    currencyExchangeRateData.companyCode = this.companyCode;
    this.setState({
      currencyExchangeRateData: currencyExchangeRateData,
      currencyCodePageListForAutoCompleteList: new Array(),
      showAutoCompleteCurrencyCodeList: false,
      tocurrencyCodePageListForAutoCompleteList: new Array(),
      showAutoCompletetoCurrencyCodeList: false,
    });
  };

  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };

  saveCurrencyExchangeRateResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeCurrencyExchangeRateEntryForm();
  };

  saveCurrencyExchangeRate = () => {
    let currencyCode = this.state.currencyExchangeRateData;
    if (currencyCode.isFetched == true) {
      if (
        SecurityAccessManager.CurrencyExchangeRateMaintenanceEdit_IsAccessible()
      ) {
        MasterService.updateCurrencyExchangeRate(
          currencyCode,
          this.saveCurrencyExchangeRateResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.CurrencyExchangeRateMaintenanceCreate_IsAccessible()
      ) {
        MasterService.createCurrencyExchangeRate(
          currencyCode,
          this.saveCurrencyExchangeRateResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  date = () => {
    let currencyExchangeRateData = this.state.currencyExchangeRateData;
    if (isEmpty(currencyExchangeRateData.date)) {
      let date = new Date();
      date = date.toLocaleDateString("sv-SE");
      currencyExchangeRateData.date = date;
      this.setState({
        currencyExchangeRateData: currencyExchangeRateData,
      });
    }
  };
  editCurrencyExchangeRateResponse = (response) => {
    if (response.data != null) {
      if (response.data.currencyExchangeRateBean != null) {
        let currencyExchangeRateBean = response.data.currencyExchangeRateBean;
        this.setState({
          currencyExchangeRateData: currencyExchangeRateBean,
        });
        this.disable();
      }
    }
    this.date();
    this.openCurrencyExchangeRateEntryForm();
  };

  onCurrencyCodeChange = (e) => {
    let fromCurrencyCode = e.target.value;
    this.state.showAutoCompleteCurrencyCodeList = true;
    let temp_data = this.state.currencyExchangeRateData;
    let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
    if (isEmpty(fromCurrencyCode)) {
      this.state.showAutoCompleteCurrencyCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
      let soLine = this.state.currencyExchangeRateData;
      soLine.fromCurrencyCode = "";
      soLine.fromCurrencyName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        currencyExchangeRateData: soLine,
        currencyCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fromCurrencyCode !== "") {
      this.readCurrencyCodeBySearchString(fromCurrencyCode);
    }
    if (e.target.name == "fromCurrencyCode") {
      temp_data["fromCurrencyCode"] = e.target.value;
      let currencyCode_List = this.state.currencies;
      currencyCode_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_data["fromCurrencyCode"] = pdtType.code;
          this.state.showAutoCompleteCurrencyCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCurrencyCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ currencyExchangeRateData: temp_data });
  };
  readCurrencyCodeBySearchString(searchString) {
    let currencyCodeData = this.state.currencies;
    let simpleAutoCompleteList = new Array();
    if (currencyCodeData.length > 0 && currencyCodeData != null) {
      currencyCodeData.map((currencyCodeDatas) => {
        let simpleItemBean = {
          code: currencyCodeDatas.code,
          description: currencyCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecurrencyCodeLists) =>
        simpleAutoCompletecurrencyCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      currencyCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  currencyCodeEnterKeyEvent = (e) => {
    let temp_data = this.state.currencyExchangeRateData;
    temp_data["fromCurrencyCode"] = e.target.value;
    let CurrencyCode_List = this.state.currencies;
    let CurrencyCodeBean = null;
    CurrencyCode_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        CurrencyCodeBean = pdtType;
      }
    });
    if (!isEmpty(CurrencyCodeBean)) {
      let temp_data = this.state.currencyExchangeRateData;
      temp_data.fromCurrencyCode = CurrencyCodeBean.code;
      temp_data.fromCurrencyName = CurrencyCodeBean.description;
      this.setState({
        currencyExchangeRateData: temp_data,
        currencyCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCurrencyList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCurrencyCodeList: showAutoCompleteList });
  };

  onToCurrencyCodeChange = (e) => {
    let toCurrencyCode = e.target.value;
    this.state.showAutoCompletetoCurrencyCodeList = true;
    let temp_data = this.state.currencyExchangeRateData;
    let showAutoCompleteList = this.state.showAutoCompletetoCurrencyCodeList;
    if (isEmpty(toCurrencyCode)) {
      this.state.showAutoCompletetoCurrencyCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompletetoCurrencyCodeList;
      let soLine = this.state.currencyExchangeRateData;
      soLine.toCurrencyCode = "";
      soLine.toCurrencyName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        showAutoCompletetoCurrencyCodeList: false,
        currencyExchangeRateData: soLine,
        tocurrencyCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && toCurrencyCode !== "") {
      this.readToCurrencyCodeBySearchString(toCurrencyCode);
    }
    if (e.target.name == "toCurrencyCode") {
      temp_data["toCurrencyCode"] = e.target.value;
      let currencyCode_List = this.state.currencies;
      currencyCode_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_data["toCurrencyCode"] = pdtType.code;
          this.state.showAutoCompletetoCurrencyCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompletetoCurrencyCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ currencyExchangeRateData: temp_data });
  };
  readToCurrencyCodeBySearchString(searchString) {
    let currencyCodeData = this.state.currencies;
    let simpleAutoCompleteList = new Array();
    if (currencyCodeData.length > 0 && currencyCodeData != null) {
      currencyCodeData.map((currencyCodeDatas) => {
        let simpleItemBean = {
          code: currencyCodeDatas.code,
          description: currencyCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecurrencyCodeLists) =>
        simpleAutoCompletecurrencyCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      tocurrencyCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  toCurrencyCodeEnterKeyEvent = (e) => {
    let temp_data = this.state.currencyExchangeRateData;
    temp_data["toCurrencyCode"] = e.target.value;
    let CurrencyCode_List = this.state.currencies;
    let CurrencyCodeBean = null;
    CurrencyCode_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        CurrencyCodeBean = pdtType;
      }
    });
    if (!isEmpty(CurrencyCodeBean)) {
      let temp_data = this.state.currencyExchangeRateData;
      temp_data.toCurrencyCode = CurrencyCodeBean.code;
      temp_data.toCurrencyName = CurrencyCodeBean.description;
      this.setState({
        currencyExchangeRateData: temp_data,
        currencyCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  todisplayAutoCompleteCurrencyList = (showAutoCompleteList) => {
    showAutoCompleteList = false;
    this.setState({ showAutoCompletetoCurrencyCodeList: showAutoCompleteList });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  save = () => {
    this.saveCurrencyExchangeRate();
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeCurrencyExchangeRateEntryForm();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.clickGoButton();
    }, 200);
  };

  clickGoButton = () => {
    let currencyExchangeRateData = this.state.currencyExchangeRateData;
    this.editCurrencyCode(currencyExchangeRateData.code);
  };

  editCurrencyCode = (code) => {
    let readRequest = new RestReadRequest();
    readRequest.companyCode = this.companyCode;
    readRequest.code = code;
    if (
      SecurityAccessManager.CurrencyExchangeRateMaintenanceView_IsAccessible()
    ) {
      MasterService.readCurrencyExchangeRate(
        readRequest,
        this.editCurrencyExchangeRateResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  openCurrencyExchangeRateEntryForm = () => {
    this.setState({
      isCurrencyExchangeRateListFormOpen: false,
      isCurrencyExchangeRateEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeCurrencyExchangeRateEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isCurrencyExchangeRateListFormOpen: true,
      isCurrencyExchangeRateEntryFormOpen: false,
      isShowSaveButton: false,
      isShowBackButton: false,
      isPageListToolBar: true,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
      currencyCodePageListForAutoCompleteList: new Array(),
      showAutoCompleteCurrencyCodeList: false,
      tocurrencyCodePageListForAutoCompleteList: new Array(),
      showAutoCompletetoCurrencyCodeList: false,
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  onChange = (e) => {
    let currencyExchangeRateData = this.state.currencyExchangeRateData;
    currencyExchangeRateData[e.target.name] = e.target.value;
    this.setState({ currencyExchangeRateData: currencyExchangeRateData });
  };

  loadCurrencyExchangeRateResponse = (response) => {
    if (
      response.data != null &&
      response.data.currencyExchangeRatePageList != null
    ) {
      let currencyExchangeRates = new Array();
      if (
        !isEmptyArray(
          response.data.currencyExchangeRatePageList.currencyExchangeRates
        )
      ) {
        currencyExchangeRates =
          response.data.currencyExchangeRatePageList.currencyExchangeRates;
      }
      currencyExchangeRates.map((Info) => {
        if (Info.isActive == true) {
          Info.isActive = "True";
        } else {
          Info.isActive = "False";
        }
      });
      let pageList = this.state.pageList;
      pageList.currentPage =
        response.data.currencyExchangeRatePageList.currentPage;
      pageList.pageSize = response.data.currencyExchangeRatePageList.pageSize;
      pageList.totalCount =
        response.data.currencyExchangeRatePageList.totalCount;
      this.setState({
        currencyExchangeRateList: currencyExchangeRates,
        pageList: pageList,
      });
    }
  };

  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new CurrencyExchangeRateSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadCurrencyExchangeRatePage(criteria, pageInput);
  };
  loadCurrencyExchangeRatePage = (criteria, pageList) => {
    let requestInput = new RestCurrencyExchangeRateListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (
      SecurityAccessManager.CurrencyExchangeRateMaintenanceView_IsAccessible()
    ) {
      MasterService.getCurrencyExchangeRatePageList(
        requestInput,
        this.loadCurrencyExchangeRateResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.currencyExchangeRateList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ currencyExchangeRateList: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}

        {this.state.isCurrencyExchangeRateListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isCurrencyExchangeRateListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}
        {this.state.isCurrencyExchangeRateListFormOpen && (
          <CurrencyExchangeRateListForm
            {...this.state}
            onChange={this.onChange}
            clickGoButton={this.clickGoButton}
            editCurrencyCode={this.editCurrencyCode}
            enterKeyEventHandler={this.enterKeyEventHandler}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state.isCurrencyExchangeRateEntryFormOpen && (
          <CurrencyExchangeRateEntryForm
            {...this.state}
            onChange={this.onChange}
            onCurrencyCodeChange={this.onCurrencyCodeChange}
            currencyCodeEnterKeyEvent={this.currencyCodeEnterKeyEvent}
            displayAutoCompleteCurrencyList={
              this.displayAutoCompleteCurrencyList
            }
            onToCurrencyCodeChange={this.onToCurrencyCodeChange}
            toCurrencyCodeEnterKeyEvent={this.toCurrencyCodeEnterKeyEvent}
            todisplayAutoCompleteCurrencyList={
              this.todisplayAutoCompleteCurrencyList
            }
          />
        )}
      </div>
    );
  }
}

function CurrencyExchangeRateAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <CurrencyExchangeRateList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default CurrencyExchangeRateAttributeModule;
